(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bcs-collection-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bcs-collection-showcase')) {
    customElements.define('bcs-collection-showcase', class extends HTMLElement {});
  }

  document.addEventListener('click', (event) => {
    const section = event.target.closest('[data-bcs-collection-showcase]');
    if (!section) return;

    const dialog = section.querySelector('[data-bcs-filter-dialog]');
    if (!dialog) return;

    if (event.target.closest('[data-bcs-filter-open]')) {
      dialog.showModal();
      return;
    }

    if (event.target.closest('[data-bcs-filter-close]') || event.target === dialog) {
      dialog.close();
    }
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-bcs-price-input]');
    if (!input) return;

    const range = input.closest('[data-bcs-price-range]');
    const filter = range?.closest('.bcs-showcase-price-filter');
    const minInput = range?.querySelector('[data-bcs-price-input="min"]');
    const maxInput = range?.querySelector('[data-bcs-price-input="max"]');
    if (!range || !filter || !minInput || !maxInput) return;

    if (Number(minInput.value) > Number(maxInput.value)) {
      if (input === minInput) maxInput.value = minInput.value;
      else minInput.value = maxInput.value;
    }

    const maximum = Number(maxInput.max) || 1;
    range.style.setProperty('--bcs-price-min', `${(Number(minInput.value) / maximum) * 100}%`);
    range.style.setProperty('--bcs-price-max', `${(Number(maxInput.value) / maximum) * 100}%`);

    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency: range.dataset.currency || 'AUD',
      currencyDisplay: 'narrowSymbol',
    });
    filter.querySelector('[data-bcs-price-min-output]').textContent = formatter.format(Number(minInput.value));
    filter.querySelector('[data-bcs-price-max-output]').textContent = formatter.format(Number(maxInput.value));
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('.bcs-showcase-filter-form');
    if (!form) return;

    const minInput = form.querySelector('[data-bcs-price-input="min"]');
    const maxInput = form.querySelector('[data-bcs-price-input="max"]');
    if (minInput && Number(minInput.value) <= Number(minInput.min || 0)) minInput.disabled = true;
    if (maxInput && Number(maxInput.value) >= Number(maxInput.max)) maxInput.disabled = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
